import React, { Button, Component, useState } from "react";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../../widgets/tables/Table";
import WaitDialog from "../../../widgets/WaitDialog";

import SendMailWidget from "../../../widgets/SendMailWidget";
import SendNotificationWidget from "../../../widgets/SendNotificationWidget";
import GetStudenti from "../../../services/getStudentiForBilling";
import addNotification from "../../../services/addNotification";
import sendMail from "../../../services/sendMail";
import saveFile from "../../../services/saveFile";
import getSetting from "../../../services/getSetting";
import Utils from "../../../utils/utils";
import Constants from "../../../utils/consts";
import WaitDialogFileDownload from "../../../widgets/WaitDialogFileDownload";
import getAnniAccademici from "../../../services/getAnniAccademici";

export default class Ritirati extends React.Component {
	constructor(props) {
		super(props);

		this.pageDiv = {
			border: "1px solid #cccccc",
			padding: 10,
		};

		this.pageTitle = props.pageTitle;
		this.pageName = props.pageName;
		if (this.pageName == undefined) {
			this.pageName = this.section;
		}

		this.options = [{ value: "All", label: "All" }];

		this.selectRef = React.createRef();

		this.state = {
			testo: "",
			menuBackground: "#ffffff",
			menuItemColor: "#000000",
			fontSize: 50,
			fontBold: false,
			logoPicture: "",
			logoMargin: 0,
			titleColor: "#000000",
			titleSize: 18,
			isLoading: false,
			addElementVisible: false,
			waitDialogVisible: false,
			mailCompaniesList: [],
		};

		this.grid = 2;

		this.pdfElements = [];

		this.studenti = [];
		this.pageTitle = "Studenti ritirati";
		this.brokerId = undefined;

		const cookies = new Cookies();
		var strJson = JSON.stringify({ list: [] });
		cookies.set("checksList", strJson, { path: "/" });

		this.sendMailRef = React.createRef();
		this.sendNotificationRef = React.createRef();

		this.state = {
			anni_accademici: [{ value: "", label: "" }],
			anno_accademico: { value: "", label: "" },
			waitDialogFileVisible: false,
			fileReady: false,
		};
	}

	async reload() {
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });

		this.studenti = await GetStudenti(username, token);
		this.anni = await getAnniAccademici(username, token);

		this.studenti = this.studenti.filter(s => s.disabled == 1);

		var options = [];
		options.push({ value: "", label: "" });

		for (var anno of this.anni) {
			if (anno.anno != "") options.push({ value: anno.anno, label: anno.anno });
		}

		this.setState({ anni_accademici: options });
	}

	async componentDidMount() {
		await this.reload();
	}

	render() {
		var headCells = [
			//  { id: '__', numeric: false, disablePadding: true, label: '' },
			{ id: "nome", numeric: false, disablePadding: true, label: "Nome" },
			{ id: "cognome", numeric: true, disablePadding: false, label: "Cognome" },
			{ id: "mail", numeric: true, disablePadding: false, label: "Mail" },
			{ id: "_", numeric: true, disablePadding: false, label: "" },
		];

		this.searchCols = ["nome", "cognome", "mail"];

		const cookies = new Cookies();

		return (
			<>
				<LoadingOverlay
					active={this.state.isLoading}
					styles={{
						content: base => ({
							position: "relative",
							width: "100%",
							top: "200px",
						}),
					}}
					spinner
					text={"Loading your content..."}
				>
					<PageTitle title={this.pageTitle} />

					<Table
						headCells={headCells}
						searchCols={this.searchCols}
						calendar={false}
						pdf={false}
						excel={false}
						mail={false}
						phone={false}
						rows={this.studenti}
						onEventClick={row => {
							cookies.set("currentStudent", row, { path: "/" });
							window.location.href = "/#/billing/studenteDetails";
						}}
					/>

					{this.elementPdf ? this.elementPdf : null}
					<SendMailWidget
						ref={this.sendMailRef}
						show={this.state.sendMailVisible}
						onClose={() => this.setState({ sendMailVisible: false })}
						onSend={async (subject, body, file) => {
							const cookies = new Cookies();
							const username = cookies.get("username", { path: "/" });
							const token = cookies.get("token", { path: "/" });
							this.mail = await getSetting(username, token, "sendingMailAddress");
							this.mailPassword = await getSetting(username, token, "sendingMailPassword");

							//            this.state.sendMailUserId
							var studente = this.studenti.find(s => s.id == this.state.sendMailUserId);
							studente.mail = studente.mail.trim();
							studente.mail2 = studente.mail2.trim();

							if (file != undefined) {
								this.filePath = await saveFile(username, token, file.name, file.base64);
							}

							if (studente.mail != "" && Utils.validateEmail(studente.mail) == false) {
								alert("L'indirizzo " + studente.mail + " non è valido");
								return;
							}
							if (studente.mail2 != "" && Utils.validateEmail(studente.mail2) == false) {
								alert("L'indirizzo " + studente.mail2 + " non è valido");
								return;
							}

							if (studente.mail != "")
								await sendMail(
									username,
									token,
									this.mail,
									"Accademia Nazionale del Cinema",
									this.mailPassword,
									studente.mail,
									studente.nome + " " + studente.cognome,
									file ? this.filePath.name : "",
									subject,
									body
								);
							if (studente.mail2 != "")
								await sendMail(
									username,
									token,
									this.mail,
									"Accademia Nazionale del Cinema",
									this.mailPassword,
									studente.mail2,
									studente.nome + " " + studente.cognome,
									file ? this.filePath.name : "",
									subject,
									body
								);

							this.setState({ waitDialogVisible: false });
							this.setState({ sendMailVisible: false });
						}}
					/>

					<SendNotificationWidget
						ref={this.sendNotificationRef}
						show={this.state.sendNotificationVisible}
						onClose={() => this.setState({ sendNotificationVisible: false })}
						onSend={async (subject, body, bodyFull) => {
							const cookies = new Cookies();
							const username = cookies.get("username", { path: "/" });
							const token = cookies.get("token", { path: "/" });

							await addNotification(
								username,
								token,
								"STUDENTE",
								this.state.notificationUser,
								subject,
								body,
								bodyFull,
								0
							);

							this.setState({ waitDialogVisible: false });
							this.setState({ sendNotificationVisible: false });
						}}
					/>

					<WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index} />
					<WaitDialogFileDownload
						onClose={() => this.setState({ waitDialogFileVisible: false })}
						show={this.state.waitDialogFileVisible}
						ready={this.state.fileReady}
						file={"https://" + Constants.mainUrl + "pdf/rate_studenti.xlsx"}
						key={Math.random()}
						index={this.state.index}
					/>
				</LoadingOverlay>
			</>
		);
	}
}
